const SearchFilterIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.14301 7.60986H21.8573"
        stroke="#212529"
        strokeWidth="1.56696"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.27695 12.833H18.7234"
        stroke="#212529"
        strokeWidth="1.56696"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4109 18.0562H15.5895"
        stroke="#212529"
        strokeWidth="1.56696"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SearchFilterIcon
